export default __webpack_public_path__ + "static/media/cloud.7f908797.webp";